import React, { useState } from "react";
import PropTypes from "prop-types";
import { List, Text, IconSvgButton, Flex, Box } from "samba-ui";
import Popup from "reactjs-popup";
import SinglePermission from "./SinglePermission";
import PermissionModal from "./PermissionModal";
import CommonPermissions from "./CommonPermissions";

const Permissions = ({
  filters = [],
  onFilterNew,
  onFilterDelete,
  onFilterUpdate,
  dashboardType,
  user
}) => {
  const isSuperOperator = user.role === "superoperator";
  const [
    isAddNewPermissionModalOpen,
    setIsAddNewPermissionModalOpen
  ] = useState(false);

  const onSubmit = body => {
    setIsAddNewPermissionModalOpen(false);
    onFilterNew([body]);
  };

  return (
    <Box>
      <List.Header borderColor="#d6d6d6 !important">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          fontWeight={500}
        >
          <Box width={1 / 6}>
            <Text fontSize={1} color="secondary">
              Name
            </Text>
          </Box>
          <Box width={1 / 6}>
            <Text fontSize={1} color="secondary">
              Filter Name
            </Text>
          </Box>
          <Box width={3 / 12}>
            <Text fontSize={1} color="secondary">
              Filter Values
            </Text>
          </Box>
          <Box width={1 / 12}>
            <Text fontSize={1} color="secondary">
              Date Range Filter
            </Text>
          </Box>
          <Box width={1 / 12}>
            <Text fontSize={1} color="secondary">
              Visible
            </Text>
          </Box>
          <Box width={1 / 12}>
            <Text fontSize={1} color="secondary">
              Default
            </Text>
          </Box>
          <Box
            width={1 / 6}
            textAlign="center"
            style={{ position: "relative" }}
          >
            <Popup
              key={user.userId}
              contentStyle={{
                width: 260,
                borderRadius: 4,
                padding: 12,
                borderColor: "#CFD6E6"
              }}
              trigger={() => (
                <Box>
                  <IconSvgButton
                    disabled={isSuperOperator}
                    variant="primaryBordered"
                    name="add-o"
                  >
                    Permission
                  </IconSvgButton>
                </Box>
              )}
              on="hover"
              position="bottom center"
              closeOnDocumentClick
            >
              <CommonPermissions
                filters={filters}
                onFilterNew={onFilterNew}
                dashboardType={dashboardType}
                setIsAddNewPermissionModalOpen={setIsAddNewPermissionModalOpen}
              />
            </Popup>
          </Box>
        </Flex>
      </List.Header>
      {!filters.length ? (
        <List.Empty>Please add new permission</List.Empty>
      ) : (
        filters.map(filter => (
          <SinglePermission
            user={user}
            key={filter.id}
            {...filter}
            onFilterUpdate={onFilterUpdate}
            onFilterDelete={onFilterDelete}
          />
        ))
      )}
      <PermissionModal
        isOpen={isAddNewPermissionModalOpen}
        onClose={() => setIsAddNewPermissionModalOpen(false)}
        onSubmit={onSubmit}
      />
    </Box>
  );
};

Permissions.propTypes = {
  filters: PropTypes.array,
  onFilterNew: PropTypes.func,
  onFilterDelete: PropTypes.func,
  onFilterUpdate: PropTypes.func,
  user: PropTypes.object,
  dashboardType: PropTypes.string
};

export default Permissions;
